import React, { useEffect, useState, lazy, Suspense, useRef } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/placeholder.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import './styles.scss'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import * as d3 from 'd3'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { StandaloneIFrame } from 'components/standaloneIFrame'
import { Link } from '@ta-interaktiv/contentbricks'
import { ArticleTeaser } from '../articleLink'
import { KeyEntry } from '../globalDrawFunctions'
import * as utils from '../../utils'
import { MultilineChartCountry } from 'components/CompareChart_3'
import { Summary } from 'components/summary'
import { HospChart } from 'components/hospChart'
import { DeathChart } from 'components/deathChart'
import { VaccCantons } from 'components/vaccCantons'
import { VaccInternational } from 'components/vaccInternational'
import { ReadMore } from 'components/readMore'
import { InlineSVG } from 'components/inlineSvg'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { Waypoint } from 'react-waypoint'
import smoothscroll from 'smoothscroll-polyfill'

smoothscroll.polyfill()

const ARTICLE_ID = '30473063'

export function AppComponent() {
  const waypointInterval = useRef({
    count: 0,
    fnc: null
  })

  const domain = parseHostname().publicationDomain
  const url =
    'https://www.' +
    domain +
    '/nos-derniers-graphiques-sur-le-covid-en-suisse-425384226557'

  setTimeout(() => {
    window.location.replace(url)
  }, 5000)
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical fitted segment'>
        <div className='ui container'>
          <div className='ta kicker'>Les chiffres clés du Covid-19</div>
          <h1 className='ui header' style={{ marginBottom: 0 }}>
            Nos derniers graphiques sur la pandémie en Suisse
          </h1>
          <h2 className='ui header' style={{ marginTop: 0 }}>
            <div className='small sub header'>
              Nombre de cas, hospitalisations de personnes vaccinées ou non: les
              données sur l’évolution de la pandémie décryptées en infographies,
              par canton et par pays.
            </div>
          </h2>

          <div className='ta metainfo'>
            <div className='ta author'>
              <span>
                Fanny Giroud, Paul Ronga, Mathieu Rudaz et l’équipe TA
                Interaktiv
              </span>
            </div>
            <div className='ta updated'>Mis à jour continuellement</div>
          </div>
        </div>
      </header>

      <div className='ui vertical fitted segment'>
        <div className='ui vertical segment block'>
          <div className='ui text container'>
            <div className='ui warning message'>
              <b>Migration</b>
              <p>
                Cette page n’est plus compatible avec notre plateforme Web. Vous
                allez être redirigé vers la page suivante:
                <br />
                <a href={url}>{url}</a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui container'>
          <h4 className='ui header'>Plus d’articles sur ce thème</h4>
          <ArticleTeasers
            numberOfCards='three'
            articleIds={[
              '232027323677', // Pourquoi la «grande vague» ne déferle pas sur les hôpitaux
              '199903768205', // La 5e vague de Covid-19 est-elle plus forte que la 2e?
              '281658773601', // Calculez dans quelles situations le risque est le plus élevé
              '945354485376', // Les dix fiches des vaccins les plus connus
              '202464158081', // L’efficacité vaccinale diminue aussi en Suisse
              '847522530745' // Comment la Suisse s’en est tirée face à ses voisins
            ]}
          />
        </div>
      </div>

      <Footer
        locale='fr'
        hidePortfolioTeaser
        mailTo='interactif@tamedia.ch '
        articleId={ARTICLE_ID}
        credits={[
          [
            'Textes et recherches',
            'Fanny Giroud, Paul Ronga, Mathieu Rudaz, Marc Brupbacher, Jonas Nart, Patrick Vögeli, Sebastian Broschinski, Mathias Lutz et Duc-Quang Nguyen (jusqu’en juin 2021)'
          ],
          [
            'Conception',
            'Mathieu Rudaz, Paul Ronga, Patrick Vögeli, Sebastian Broschinski, Mathias Lutz'
          ],
          ['Mise à jour', '03.05.2022, 16:10']
        ]}
        questions={[
          'Ce contenu était-il informatif?',
          'La mise en oeuvre a-t-elle fonctionné?',
          'La mise en forme vous plaît-elle?'
        ]}
      />
    </div>
  )
}
const Loader = ({
  children,
  additionalClasses = ''
}: {
  children?: string | JSX.Element
  additionalClasses?: string
}) => (
  <Segment>
    <div className={'ui active inverted dimmer ' + additionalClasses}>
      <div className='ui text loader'>{children}</div>
    </div>
  </Segment>
)
const Segment = ({
  children,
  additionalClasses = ''
}: {
  children?: string | JSX.Element
  additionalClasses?: string
}) => (
  <div className={'ui vertical ' + additionalClasses + ' segment'}>
    {children && children}
  </div>
)
const WideColumn = ({
  children,
  additionalClasses = ''
}: {
  children?: string | JSX.Element
  additionalClasses?: string
}) => (
  <div className={'ui container ' + additionalClasses}>
    {children && children}
  </div>
)
const TextColumn = ({
  children,
  additionalClasses = ''
}: {
  children?: string | JSX.Element
  additionalClasses?: string
}) => (
  <div className={'ui text container ' + additionalClasses}>
    {children && children}
  </div>
)
const HalfLeft = ({
  children,
  additionalClasses = ''
}: {
  children?: string | JSX.Element
  additionalClasses?: string
}) => (
  <div className={'gContainer w50 left ' + additionalClasses}>
    {children && children}
  </div>
)
const HalfRight = ({
  children,
  additionalClasses = ''
}: {
  children?: string | JSX.Element
  additionalClasses?: string
}) => (
  <div className={'gContainer w50 right ' + additionalClasses}>
    {children && children}
  </div>
)
const FullWidth = ({
  children,
  additionalClasses = ''
}: {
  children?: string | JSX.Element
  additionalClasses?: string
}) => (
  <div className={'gContainer w100 ' + additionalClasses}>
    {children && children}
  </div>
)
